export const planningOnlineMain = {
    legends: {
        first: "nouveaux patients via le planning en ligne"
    },
    title: "Statistiques planning en ligne",
    loading: "Chargement en cours…",
    'evolution-title': "Évolution des nouveaux patients (en {year})"
}